export default {"src":"/_next/static/media/UpArrow.febc6ab9.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};